<template>
  <div class="payment-container">
    <div class="payment-content">
      <div class="payment-header">
        <h1 class="payment-title earth-color">
          Booking Confirmed
        </h1>
        <div class="payment-progress">
          <div class="progress-step">Details</div>
          <div class="progress-step">Payment</div>
          <div class="progress-step active">Confirmation</div>
        </div>
      </div>

      <div class="main-content success-content">
        <!-- Success Icon -->
        <div class="icon-circle">
          <i class="fas fa-check-circle"></i>
        </div>

        <h2 class="success-title">Booking Confirmed</h2>
        <p class="success-subtitle">
          Your payment has been received. Thank you, 
          <span style="text-transform: capitalize; font-weight: 600;">{{ singleBooking.booking_details.first_name }}</span>!
        </p>

        <!-- Summary Card -->
        <div class="summary-card">
          <div class="summary-row">
            <span class="summary-label">Booking REF</span>
            <span class="summary-value">{{ singleBooking.booking_ref_code }}</span>
          </div>
          
          <div class="summary-row">
            <span class="summary-label">Total Paid</span>
            <span class="summary-value">
              {{ singleBooking.currency }}
              {{ singleBooking.total_cost ? singleBooking.total_cost.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,") : '0.00' }}
            </span>
          </div>

          <div class="summary-row">
            <span class="summary-label">Total Guests</span>
            <span class="summary-value">{{ singleBooking.guest_total }}</span>
          </div>

          <div class="summary-row">
            <span class="summary-label">Status</span>
            <span class="summary-value text-success">{{ singleBooking.booking_payment_status }}</span>
          </div>
        </div>

        <!-- Detailed Itinerary -->
        <div class="itinerary-section">
          <div class="itinerary-block">
            <h3 class="methods-title">Dates Selected</h3>
            <p><strong>Check-in:</strong> {{ singleBooking.check_in_date }}</p>
            <p><strong>Check-out:</strong> {{ singleBooking.check_out_date }}</p>
          </div>

          <div class="itinerary-block">
            <h3 class="methods-title">Conservation Entry Fees</h3>
            <ul>
              <li v-for="(guest, key) in singleBooking.guests"
                  v-if="guest.payment_guests > 0"
                  :key="key">
                {{ guest.payment_person }}: <b>{{ guest.payment_guests }}</b>
              </li>
            </ul>
          </div>

          <div class="itinerary-block" v-if="singleBooking.facility_bookings && singleBooking.facility_bookings.length > 0">
            <h3 class="methods-title">Accommodation Selected</h3>
            <ul>
              <li v-for="(facility, key) in singleBooking.facility_bookings" :key="key">
                {{ facility.facility_name }}
              </li>
            </ul>
          </div>

          <div class="itinerary-block" v-if="singleBooking.inventory_bookings && singleBooking.inventory_bookings.length > 0">
            <h3 class="methods-title">Conservation Activities</h3>
            <ul>
              <li v-for="(activity, key) in singleBooking.inventory_bookings" :key="key">
                {{ activity.inventory_name }} on {{ formated_date(activity.inventory_booking_date) }} 
                ({{ activity.inventory_booking_adults }} adults, {{ activity.inventory_booking_children }} children)
              </li>
            </ul>
          </div>

          <div class="itinerary-block">
            <h3 class="methods-title">Vehicle Fee</h3>
            <p><b>{{ singleBooking.vehicle_count }}</b> vehicles</p>
          </div>
        </div>

        <!-- Email Confirmation Notice -->
        <div class="email-confirmation">
          <i class="fas fa-envelope"></i>
          <p>
            An email confirmation has been sent to
            <b>{{ singleBooking.booking_details.email_address }}</b>
          </p>
        </div>

        <!-- Action Button -->
        <div class="action-footer">
          <router-link to="/" style="text-decoration: none; width: 100%;">
            <button class="home-btn">
              <i class="fas fa-home mr-2"></i> Back to Home
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    beforeCreate() {
      this.$store.dispatch("get_booking", this.$route.params.booking_id);
      this.$store.dispatch("get_all_facility_pricing_types");
      localStorage.setItem("credit_note_guests", JSON.stringify([]));
      localStorage.setItem("credit_note_vehicles", JSON.stringify([]));
      localStorage.setItem("credit_note_accommodations", JSON.stringify([]));
      localStorage.setItem("credit_note_external_accommodations", JSON.stringify([]));
      localStorage.setItem("credit_note_activities", JSON.stringify([]));
    },
    created() {
      this.$store.dispatch("get_booking", this.$route.params.booking_id);
    },
    methods: {
      formated_date(date) {
        if (!date) return '';
        return date;
      }
    }
  };
</script>

<style scoped>
  @font-face {
    font-family: 'Earthwerk';
    src: url('PizzaDude.dk-Earthwerk.otf');
    font-weight: normal;
    font-style: normal;
  }

  /* ============================================
     MAIN CONTAINER
     ============================================ */
  .payment-container {
    background-color: #f9f9f9;
    min-height: 100vh;
    padding: 20px;
  }

  /* ============================================
     PAYMENT HEADER
     ============================================ */
  .payment-header {
    text-align: center;
    margin-bottom: 30px;
    padding: 20px;
    background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  .payment-title {
    font-family: 'Earthwerk', sans-serif;
    font-size: 2.5rem;
    margin-bottom: 15px;
    letter-spacing: 1px;
    color: #4a6b22;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
  }

  .payment-progress {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 20px;
  }

  .progress-step {
    padding: 10px 20px;
    margin: 0 10px;
    background-color: #e0e0e0;
    border-radius: 20px;
    font-weight: 500;
    color: #666;
    position: relative;
    font-size: 0.9rem;
  }

  .progress-step.active {
    background-color: #74a533;
    color: white;
    box-shadow: 0 4px 8px rgba(116, 165, 51, 0.3);
  }

  .progress-step:not(:last-child):after {
    content: '→';
    position: absolute;
    right: -15px;
    color: #999;
  }

  /* ============================================
     CONTENT LAYOUT
     ============================================ */
  .payment-content {
    max-width: 1200px;
    margin: 0 auto;
  }

  .success-content {
    background-color: white;
    border-radius: 12px;
    padding: 30px 20px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  /* ============================================
     SUCCESS ICON & HEADINGS
     ============================================ */
  .icon-circle {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #f0f7e6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }

  .icon-circle i {
    font-size: 60px;
    color: #74a533;
  }

  .success-title {
    font-family: 'Earthwerk', sans-serif;
    font-size: 2rem;
    color: #2d4a1e;
    margin: 0 0 8px 0;
  }

  .success-subtitle {
    font-size: 1rem;
    color: #555;
    margin-bottom: 30px;
  }

  /* ============================================
     SUMMARY CARD
     ============================================ */
  .summary-card {
    width: 100%;
    max-width: 500px;
    background-color: #fafafa;
    border-radius: 12px;
    padding: 16px 20px;
    margin-bottom: 30px;
    border: 1px solid #eee;
    text-align: left;
  }

  .summary-row {
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid #eee;
  }

  .summary-row:last-child {
    border-bottom: none;
  }

  .summary-label {
    color: #777;
    font-size: 0.9rem;
  }

  .summary-value {
    font-weight: 600;
    color: #333;
    font-size: 0.95rem;
  }

  .text-success {
    color: #74a533;
  }

  /* ============================================
     ITINERARY DETAILS
     ============================================ */
  .itinerary-section {
    width: 100%;
    max-width: 600px;
    text-align: left;
    margin-bottom: 30px;
  }

  .itinerary-block {
    margin-bottom: 20px;
    background: #fff;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  }

  .itinerary-block p {
    margin: 4px 0;
    font-size: 0.95rem;
  }

  .methods-title {
    font-family: 'Earthwerk', sans-serif;
    font-size: 1.1rem;
    margin-bottom: 10px;
    color: #4a6b22;
    border-bottom: 2px solid #eef3e8;
    padding-bottom: 6px;
  }

  .itinerary-block ul {
    padding-left: 20px;
    margin: 8px 0;
  }

  .itinerary-block ul li {
    padding: 4px 0;
    font-size: 0.9rem;
    color: #444;
  }

  /* ============================================
     EMAIL CONFIRMATION
     ============================================ */
  .email-confirmation {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    max-width: 500px;
    padding: 16px;
    background-color: #fff8e1;
    border-radius: 8px;
    font-size: 0.9rem;
    color: #8a5300;
    margin-bottom: 30px;
    text-align: left;
  }

  .email-confirmation i {
    color: #ffc107;
    font-size: 1.2rem;
  }

  .email-confirmation p {
    margin: 0;
  }

  /* ============================================
     ACTION FOOTER
     ============================================ */
  .action-footer {
    width: 100%;
    max-width: 500px;
    display: flex;
    justify-content: center;
  }

  .home-btn {
    width: 100%;
    background-color: #74a533;
    color: white;
    font-family: 'Earthwerk', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    padding: 14px 24px;
    border: none;
    border-radius: 40px;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(116, 165, 51, 0.3);
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .home-btn:hover {
    background-color: #638e2b;
    transform: translateY(-2px);
  }

  .home-btn:active {
    transform: scale(0.98);
  }

  /* ============================================
     EARTH COLOR & UTILITIES
     ============================================ */
  .earth-color {
    color: #4a6b22;
  }

  .mr-2 {
    margin-right: 8px;
  }

  /* ============================================
     RESPONSIVE BREAKPOINTS
     ============================================ */

  @media (max-width: 960px) {
    .payment-title {
      font-size: 1.8rem;
    }
    .progress-step {
      padding: 8px 16px;
      font-size: 0.8rem;
      margin: 0 6px;
    }
  }

  @media (max-width: 600px) {
    .payment-container {
      padding: 10px;
    }

    .payment-header {
      padding: 14px;
      margin-bottom: 16px;
    }

    .payment-title {
      font-size: 1.4rem;
      margin-bottom: 10px;
    }

    .payment-progress {
      gap: 4px;
      margin-top: 10px;
    }

    .progress-step {
      padding: 5px 12px;
      font-size: 0.65rem;
      margin: 0 3px;
      border-radius: 14px;
    }

    .progress-step:not(:last-child):after {
      content: '';
      display: none;
    }

    .success-content {
      padding: 20px 16px;
    }

    .icon-circle {
      width: 80px;
      height: 80px;
    }

    .icon-circle i {
      font-size: 45px;
    }

    .success-title {
      font-size: 1.6rem;
    }

    .success-subtitle {
      font-size: 0.9rem;
      margin-bottom: 20px;
    }

    .summary-card {
      padding: 12px 16px;
    }

    .itinerary-block {
      padding: 12px;
    }

    .email-confirmation {
      flex-direction: column;
      text-align: center;
      padding: 14px;
      font-size: 0.8rem;
    }
  }

  @media (max-width: 360px) {
    .payment-container {
      padding: 6px;
    }

    .success-title {
      font-size: 1.3rem;
    }

    .methods-title {
      font-size: 0.95rem;
    }

    .home-btn {
      font-size: 0.95rem;
      padding: 12px 20px;
    }
  }

  @media (min-width: 1200px) {
    .payment-title {
      font-size: 2.8rem;
    }
  }
</style>